import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";

// React Query
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
//React Router
import { BrowserRouter } from "react-router-dom";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
